<!-- src/components/MessageCTA.vue -->
<template>
  <div class="mt-4 flex flex-wrap gap-2">
    <button
      v-for="button in cta.buttons"
      :key="button.text"
      @click="$emit('suggestion', button.text)"
      class="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded-full transition-colors"
    >
      {{ button.text }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  cta: {
    type: Object,
    required: true,
  },
});

defineEmits(["suggestion"]);
</script>
